import React from 'react'
import { Line } from 'react-chartjs-2'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
} from 'chart.js'
import { formatPeriodo } from './utils'

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler)

const COLORS = [
    '#ef476f', '#ffd166', '#06d6a0', '#118ab2', '#a78bfa',
    '#f78c6b', '#2ec4b6', '#e63946', '#8ac926', '#ff9f1c',
    '#4cc9f0', '#c9184a', '#588157', '#9d4edd',
]

export const MultiLineChart = ({ serieData, title }) => {
    const granularidad = serieData?.granularidad || 'day'
    const vendedores = serieData?.vendedores ?? []

    const periodosSet = new Set()
    vendedores.forEach((v) => v.serie.forEach((p) => periodosSet.add(p.periodo)))
    const periodos = Array.from(periodosSet).sort()
    const labels = periodos.map((p) => formatPeriodo(p, granularidad))

    const datasets = vendedores.map((v, idx) => {
        const byPeriodo = new Map(v.serie.map((p) => [p.periodo, p.total]))
        const color = COLORS[idx % COLORS.length]
        return {
            label: v.nombre || `#${v.user_id}`,
            data: periodos.map((p) => byPeriodo.get(p) || 0),
            borderColor: color,
            backgroundColor: color,
            tension: 0.35,
            pointRadius: 2,
            pointHoverRadius: 6,
            pointHitRadius: 10,
            borderWidth: 2,
        }
    })

    const misoptions = {
        responsive: true,
        maintainAspectRatio: false,
        // intersect: true + mode: 'nearest' -> el tooltip muestra SOLO el punto tocado,
        // no todos los vendedores en ese periodo (con muchas líneas era ilegible).
        interaction: { mode: 'nearest', intersect: true },
        plugins: {
            legend: {
                position: 'bottom',
                labels: { color: 'rgba(170,170,170)', boxWidth: 12, font: { size: 10 } },
            },
            tooltip: { mode: 'nearest', intersect: true },
        },
        scales: {
            y: {
                min: 0,
                ticks: { color: 'rgba(170,170,170)' },
                grid: { color: 'rgba(170,170,170,.2)' },
            },
            x: {
                ticks: { color: 'rgba(170,170,170)', autoSkip: true, maxRotation: 45 },
                grid: { display: false },
            },
        },
    }

    return (
        <div className='w-full min-w-0'>
            <div className='text-base dark:text-gray-300 text-gray-800 font-bold text-center mb-2'>{title}</div>
            {datasets.length === 0 ? (
                <div className='text-sm text-gray-500 dark:text-gray-400 italic text-center py-8'>
                    Sin datos para el rango seleccionado
                </div>
            ) : (
                <div className='w-full min-w-0 h-72 sm:h-96'>
                    <Line data={{ labels, datasets }} options={misoptions} />
                </div>
            )}
        </div>
    )
}
